<script setup lang="ts">
import UiIcon from '@/components/core/UiIcon.vue';
import Icons from '@/constants/Icons';
import type { Component } from 'vue';

const props = withDefaults(
  defineProps<{
    as?: string | Component;
    disabled?: boolean;
    icon?: string;
    loading?: boolean;
    primary?: boolean;
    small?: boolean;
  }>(),
  {
    as: 'button',
  },
);
</script>

<template>
  <component
    :is="props.as"
    class="flex items-center justify-center gap-3 rounded font-medium"
    :class="{
      'px-5': $slots.default,
      'h-14 min-w-14 text-xl': !props.small,
      'h-12 min-w-12 text-lg': props.small,
      'cursor-not-allowed opacity-50': props.disabled,
      'ui-outline ui-touch': !props.primary,
      'hover:ui-outline-active active:ui-touch-active': !props.primary && !props.disabled,
      'bg-app-base text-white': props.primary,
      'hover:bg-app-light active:bg-app-light': props.primary && !props.disabled,
    }"
  >
    <div v-if="props.loading">
      <UiIcon class="animate-spin" :path="Icons.Core.Loading" :size="props.small ? 'sm' : 'md'" />
    </div>
    <div v-else-if="props.icon">
      <UiIcon :path="props.icon" :size="props.small ? 'sm' : 'md'" />
    </div>
    <slot />
  </component>
</template>
